import {
  createRelationship,
  getRelationships,
  deleteRelationship,
  deleteRelationships
} from "./services";

class Manager {
  createRelationship(
    targetId,
    sourceId,
    type = "relationship",
    relationshipType = "related-to"
  ) {
    const request = createRelationship(
      targetId,
      sourceId,
      type,
      relationshipType
    );

    return request;
  }

  getRelationships(targetId, sourceId, options) {
    const request = getRelationships(targetId, sourceId, options);

    return request;
  }

  deleteRelationships({targetId, sourceId}) {
    const request = deleteRelationships(targetId, sourceId);

    return request;
  }

  deleteRelationship(relationshipId) {
    const request = deleteRelationship(relationshipId);

    return request;
  }
}

const Configuration = () => {
  if (!window.atsSecurityRibbonRelationshipManager) {
    window.atsSecurityRibbonRelationshipManager = new Manager();
  }
  return window.atsSecurityRibbonRelationshipManager;
};

export default Configuration();

export const ManagerClass = Manager;
